import 'vue-multiselect/dist/vue-multiselect.min.css';

import Multiselect from 'vue-multiselect';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import ITableCol from '@/interfaces/ITableCol';
import capitalizeFirstLetter from '@/libs/capitalizeFirstLetter';

@Component({
    name: 'SelectionColumnsInTable',
    components: {
        Multiselect
    }
})
export default class SelectionColumnsInTable extends Vue {
    @Prop(Array) private tableColumns!: ITableCol[];

    private selectedTableColumns: any = [];

    private get columns() {
        const hiddenCols = ['updatedAt', 'createdAt'];
        return this.tableColumns.map((column: ITableCol) => {
            if (!hiddenCols.includes(column.key)) {
                return {
                    value: column.key,
                    label: capitalizeFirstLetter(column.key),
                    sortable: column.sortable
                }
            } else {
                return {
                    value: column.key,
                    label: capitalizeFirstLetter(column.key),
                    sortable: column.sortable,
                    isHidden: true
                }
            }
        });
    }

    @Watch('selectedTableColumns')
    private changeColumns() {
        this.$emit('changeColumns', this.selectedTableColumns)
    }

    @Watch('tableColumns')
    private getCols(){
        this.selectedTableColumns = this.columns.filter((el) => !el.isHidden);
    }

    private mounted() {
        this.getCols();
    }
}
